import { TRADABLES_TYPE } from "@helpers/constants";
import { Etf as OldEtf } from "@models/derivative/currencies/etf";
import { Tradable, TradableAdapter } from "../tradable";

export interface Etf extends Tradable {
	isin: string;
}

export class EtfAdapter extends TradableAdapter {
	public adapt(etf: OldEtf): Etf {
		const tradable = super.adapt(etf);
		return {
			...tradable,
			isin: etf.getIsin(),
			type: TRADABLES_TYPE.ETF
		};
	}
}
